import { api} from '../utils/variables';

// Local helper – mirrors userProfileApi auth header behavior
const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  'Authorization': `Bearer ${localStorage.getItem('authToken') || ''}`,
});

/**
 * Onboarding API
 * Handles first-time user onboarding flags and state.
 */
export const onboardingApi = {
  /**
   * GET /user/onboarding/status
   * Shape: { is_onboarded: boolean | null, onboarding_state: object }
   */
  getStatus: async () => {
    try {
      const response = await fetch(`${api}/user/onboarding/status`, {
        method: 'GET',
        headers: getAuthHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      // Fail silently for onboarding – should never block main flows
      // eslint-disable-next-line no-console
      console.error('Error fetching onboarding status:', error);
      throw error;
    }
  },

  /**
   * POST /user/onboarding/update
   * Updates onboarding status for a specific page or overall completion.
   * 
   * @param {Object} payload - { is_onboarded: boolean, onboarding_state: object }
   * @example
   * await onboardingApi.updateOnboarding({
   *   is_onboarded: true,
   *   onboarding_state: { ai_screen: true, keyword_explorer: true }
   * })
   */
  updateOnboarding: async (payload) => {
    try {
      const response = await fetch(`${api}/user/onboarding/update`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || `HTTP ${response.status}: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      // Do not block UI if this fails – log and continue
      // eslint-disable-next-line no-console
      console.error('Error updating onboarding status:', error);
      throw error;
    }
  },

  /**
   * POST /user/onboarding/update
   * Used when the AI screen tutorial is first shown.
   * @deprecated Use updateOnboarding instead for more flexibility
   */
  markAiScreenCompleted: async () => {
    return onboardingApi.updateOnboarding({
      is_onboarded: true,
      onboarding_state: {
        ai_screen: true,
      },
    });
  },
};

export default onboardingApi;

